import React, { useState } from 'react';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { FaUserCircle, FaBars } from 'react-icons/fa';
import ApiService from '../../services/ApiService';
import './AdminLayout.css';

function AdminLayout() {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);

  const handleLogout = () => {
    try { ApiService.logout(); } catch (_) {}
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <Container fluid className="h-100">
        <Row className="h-100">
          <Col xs={12} md={3} lg={2} className={`admin-sidebar ${showSidebar ? 'open' : ''}`}>
            <div className="admin-brand d-flex align-items-center">
              <img src="/logo.png" alt="Cajas Amanecer" className="admin-brand-logo" />
            </div>
            <nav className="admin-nav">
              <NavLink end to="/admin" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`} onClick={() => setShowSidebar(false)}>Inicio</NavLink>
              <NavLink to="/admin/productos" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`} onClick={() => setShowSidebar(false)}>Productos</NavLink>
              <NavLink to="/admin/categorias" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`} onClick={() => setShowSidebar(false)}>Categorías</NavLink>
              <NavLink to="/pedidos" className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`} onClick={() => setShowSidebar(false)}>Pedidos</NavLink>
            </nav>
          </Col>
          <Col xs={12} md={9} lg={10} className="admin-content">
            <div className="admin-header d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <button
                  type="button"
                  className="admin-menu-toggle d-md-none"
                  aria-label="Abrir menú"
                  onClick={() => setShowSidebar(prev => !prev)}
                >
                  <FaBars size={20} />
                </button>
                <h2 className="admin-header-title mb-3">Administrador</h2>
              </div>
              <Dropdown align="end">
                <Dropdown.Toggle variant="light" id="admin-user-menu" className="admin-user-toggle">
                  <FaUserCircle size={22} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={handleLogout}>Cerrar sesión</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="admin-divider" />
            <div className="admin-outlet">
              <Outlet />
            </div>
          </Col>
          {/* Overlay para cerrar el menú en mobile */}
          {showSidebar && (
            <div
              className="admin-overlay d-md-none"
              onClick={() => setShowSidebar(false)}
            />
          )}
        </Row>
      </Container>
    </div>
  );
}

export default AdminLayout;


